import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { showUsercentricsSettings } from 'gcs-common/hooks/useUsercentrics';
import { getPrivacyText, getTermsText } from 'gcs-common/slices/theme/themeSelectors';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import closeIcon from '../../img/close_white.svg';
import Button from '../Button/Button';
import styles from './styles.module.scss';

const TermsAndPrivacy = ({
  asModal = false,
  withTerms = false,
  withPrivacy = false,
  onRightBar = false,
  withOptOut = false,
}) => {
  const privacyText = useSelector(getPrivacyText);
  const termsText = useSelector(getTermsText);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClose = () => {
    if (onRightBar) {
      dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
    } else {
      navigate(-1);
    }
  };

  const header = useMemo(() => {
    if (withTerms && withPrivacy) return 'Nutzungsbedignungen & Datenschutzrichtlinien';
    return withTerms ? 'Nutzungsbedignungen' : 'Datenschutzrichtlinien';
  }, [withTerms, withPrivacy]);

  return (
    <div className={asModal ? styles.containerModal : styles.container}>
      <div className={styles.header}>
        <div>{header}</div>
        <Button className={styles.noBorder} type="button" onClick={onClose}>
          <img src={closeIcon} alt="Zurück" />
        </Button>
      </div>
      <div className={styles.textWrapper}>
        <div>{withTerms && termsText}</div>
        <div>{withPrivacy && privacyText}</div>
      </div>
      {onRightBar && (
        <div className={styles.cookieSettingsContainer}>
          <button className={styles.cookieSettingsButton} onClick={showUsercentricsSettings} type="button">
            Datenschutzeinstellungen bearbeiten
          </button>
        </div>
      )}
      {withOptOut && (
        <button className={styles.cookieSettingsButton} onClick={showUsercentricsSettings} type="button">
          Datenschutzeinstellungen bearbeiten
        </button>
      )}
    </div>
  );
};

TermsAndPrivacy.propTypes = {
  asModal: PropTypes.bool,
  withTerms: PropTypes.bool,
  withPrivacy: PropTypes.bool,
  onRightBar: PropTypes.bool,
  withOptOut: PropTypes.bool,
};

export default TermsAndPrivacy;
